module.exports = __webpack_public_path__ + "static/media/armadillo-logo-dark.5b12ef12.svg";